export class PersonaXRepLeg {
    npersonaxrlId: number;
    cpersonaxrlNombres: string;
    cpersonaxrlApepaterno: string;
    cpersonaxrlApematerno: string;
    npersonaxrlIdpersona: string;
    numItem: number;

}
